import Vue from "vue";
import Router from "vue-router";
import { DialogProgrammatic as Dialog } from "buefy";
import adminRoutes from "./admin";
import memberSettingsRoutes from "./memberSettings";
import memberQuestionsRoutes from "./memberQuestions";
import adminSuperRoutes from "./adminSuper";
import companionRoutes from "./companion";
import lazyLoading from "./lazyLoading";

Vue.use(Router);

// const maintenanceRouter = new Router({
//   mode: "history",
//   base: process.env.BASE_URL,
//   scrollBehavior: () => ({ x: 0, y: 0 }),
//   routes: [
//     {
//       path: "/",
//       name: "Maintenance",
//       components: {
//         auth: lazyLoading("Maintenance")
//       },
//       meta: {
//         auth: false
//       }
//     },
//     {
//       path: "*",
//       redirect: "/"
//     }
//   ]
// });
//
// Vue.router = maintenanceRouter;

// TODO:
//   provide a fallback for history mode.  If our server is not setup
//   to handle this then 404 redirects won't work properly
//   https://router.vuejs.org/guide/essentials/history-mode.html

// We have two routers, so that, when program creating, we don't show routes that are not needed
// and so that redirecting points to the 'create-bewell' and not the login page
// initializing these routers when needed ensures no overlap in the 'catch all' routes
// note use of meth.auth=undefined ... meaning the "create-bewell" page will still show if there is a logged in user,
/// for reference visit https://websanova.com/docs/vue-auth/guides/auth-meta#meta-values
const isCreateProgram =
  window.location.pathname.includes("create-bewell") ||
  window.location.hostname.includes("setup");

if (isCreateProgram) {
  const routerCreateProgram = new Router({
    mode: "history",
    base: process.env.BASE_URL,
    scrollBehavior: () => ({ x: 0, y: 0 }),
    // Note: "SetupPage" must be included in the route names for "/create-bewell"
    routes: [
      {
        path: "/create-bewellcore",
        name: "CreateBeWellCore",
        components: {
          createProgram: lazyLoading("SetupPage")
        }
      },
      {
        path: "/create-bewellplus",
        name: "CreateBeWellPlus",
        components: {
          createProgram: lazyLoading("SetupPage")
        }
      },
      {
        path: "/create-bewellpro",
        name: "CreateBeWellPro",
        components: {
          createProgram: lazyLoading("SetupPage")
        }
      }
    ]
  });
  Vue.router = routerCreateProgram;
} else {
  const routerApp = new Router({
    mode: "history",
    base: process.env.BASE_URL,
    scrollBehavior: () => ({ x: 0, y: 0 }),
    routes: [
      {
        path: "/mobile/organizations/:mobileToken",
        name: "OrganizationsMobile",
        components: {
          auth: lazyLoading("OrganizationsMobile")
        },
        meta: {
          auth: false
        }
      },
      {
        path: "/mobile/redirect/:mobileToken/:page/:pageId?",
        name: "MobileRedirectTo",
        components: {
          auth: lazyLoading("MobileRedirect")
        },
        meta: {
          auth: false
        }
      },
      {
        path: "/mobile/challenge/:mobileToken/:challengeId",
        name: "PreventativeChallengeMobile",
        components: {
          auth: lazyLoading("PreventativeChallengeMobile")
        },
        meta: {
          auth: false
        }
      },
      {
        path: "/mobile/registration",
        name: "MemberRegistration",
        components: {
          auth: lazyLoading("MemberRegistration")
        },
        meta: {
          auth: false
        }
      },
      {
        path: "/login",
        name: "Login",
        components: {
          auth: lazyLoading("Login")
        },
        meta: {
          auth: false
        }
      },
      {
        path: "/registration",
        name: "MemberRegistration",
        components: {
          auth: lazyLoading("MemberRegistration")
        },
        meta: {
          auth: false
        }
      },
      {
        path: "/reset-password",
        name: "ResetPassword",
        components: {
          resetPassword: lazyLoading("ResetPassword")
        },
        meta: {
          auth: undefined
        }
      },
      {
        path: "/403",
        name: "403",
        component: lazyLoading("Forbidden403")
      },
      {
        path: "/",
        redirect: "/my-dashboard"
      },
      {
        path: "/my-dashboard",
        name: "MyDashboard",
        component: lazyLoading("MyDashboard"),
        meta: {
          viewTitle: "My Dashboard",
          viewLink: true,
          linkIcon: "home",
          auth: true
        }
      },
      {
        path: "/sitewide",
        name: "Sitewide",
        component: lazyLoading("Sitewide"),
        meta: {
          viewTitle: "Sitewide",
          viewLink: true,
          linkIcon: "globe",
          auth: true
        }
      },
      {
        path: "/challenges",
        name: "Challenges",
        component: lazyLoading("Challenges"),
        meta: {
          viewTitle: "Challenges",
          viewLink: true,
          linkIcon: "challenges",
          auth: true
        }
      },
      {
        path: "/challenges/challenge-edit/:challengeId",
        name: "ChallengeEditMember",
        props: true,
        component: lazyLoading("ChallengeEdit"),
        meta: {
          viewTitle: "Challenge Edit",
          auth: true
        }
      },
      {
        path: "/challenges/:challengeId",
        name: "Challenge",
        component: lazyLoading("ChallengePage"),
        children: [
          {
            path: "milestones/:milestoneId"
          }
        ],
        meta: {
          auth: true
        }
      },
      {
        path: "/challenge-builder/:mode",
        name: "MemberChallengeBuilder",
        component: lazyLoading("MemberChallengeBuilder"),
        meta: {
          auth: true
        }
      },
      {
        path: "/friends",
        name: "Friends",
        component: lazyLoading("Friends"),
        meta: {
          viewTitle: "Friends",
          viewLink: true,
          linkIcon: "friends",
          auth: true
        }
      },
      {
        path: "/profile/:username/friends",
        name: "ProfileFriends",
        component: lazyLoading("ProfileFriends"),
        meta: {
          auth: true
        }
      },
      {
        path: "/profile/:username",
        name: "ProfilePage",
        component: lazyLoading("ProfilePage"),
        meta: {
          viewTitle: "Profile Page",
          auth: true
        }
      },
      {
        path: "/profile/:username/journals/:journalDate",
        name: "ProfileJournalPage",
        component: lazyLoading("JournalPage"),
        meta: {
          auth: true
        }
      },
      {
        path: "/journals/:journalDate",
        name: "JournalPage",
        component: lazyLoading("JournalPage"),
        meta: {
          auth: true
        }
      },
      // [MESSAGE INBOX]
      {
        path: "/messages",
        name: "Messages",
        component: lazyLoading("Messages"),
        meta: {
          viewTitle: "Messages",
          linkIcon: "icon-mail",
          auth: true
        }
      },
      // [TEAMS FEATURE]
      {
        path: "/teams",
        name: "Teams",
        component: lazyLoading("Teams"),
        meta: {
          viewTitle: "Teams",
          viewLink: true,
          linkIcon: "teams",
          auth: true
        }
      },
      // [TEAMS FEATURE]
      {
        path: "/teams/:teamId",
        name: "Team",
        component: lazyLoading("Team"),
        meta: {
          auth: true
        }
      },
      {
        path: "/teams/:teamId/members",
        name: "TeamViewAll",
        component: lazyLoading("TeamViewAll"),
        meta: {
          auth: true
        }
      },
      {
        path: "/teams/team-edit/:teamId",
        name: "MemberTeamEdit",
        props: true,
        component: lazyLoading("TeamEdit"),
        meta: {
          viewTitle: "Team Edit",
          auth: true
        }
      },
      {
        path: "/team-builder/:mode",
        name: "MemberTeamBuilder",
        component: lazyLoading("MemberTeamBuilder"),
        meta: {
          auth: true
        }
      },
      // [BADGES]
      {
        path: "/profile/:username/badges",
        name: "ProfileBadgesPage",
        component: lazyLoading("BadgesPage"),
        meta: {
          auth: true
        }
      },
      {
        path: "/badges",
        name: "BadgesPage",
        component: lazyLoading("BadgesPage"),
        meta: {
          auth: true
        }
      },
      // [POINTS FEATURE]
      {
        path: "/points",
        name: "Points",
        component: lazyLoading("Points"),
        meta: {
          viewTitle: "Points",
          linkIcon: "star-circle",
          auth: true
        }
      },
      {
        path: "/help",
        name: "Help",
        component: lazyLoading("Help"),
        meta: {
          viewTitle: "Help",
          linkIcon: "mdi-help-circle-outline",
          auth: true
        }
      },
      {
        path: "/assessment",
        name: "Assessment",
        component: lazyLoading("Assessment"),
        meta: {
          auth: true
        }
      },
      {
        path: "/info",
        name: "CustomPage",
        component: lazyLoading("CustomPage")
      },
      {
        path: "/organization",
        name: "ChooseOrganization",
        component: lazyLoading("ChooseOrganization"),
        meta: {
          viewTitle: "Organization",
          linkIcon: "star-circle",
          auth: true,
          viewLink: false
        }
      },
      {
        path: "/organization/:organizationName",
        name: "Organization",
        component: lazyLoading("Organization"),
        meta: {
          auth: true
        }
      },
      memberSettingsRoutes,
      {
        // for redirecting legacy links
        path: "/preferences",
        redirect: "member-settings/account"
      },
      memberQuestionsRoutes,
      adminRoutes,
      adminSuperRoutes,
      companionRoutes,
      {
        path: "/404",
        name: "404",
        components: {
          notFound: lazyLoading("NotFound404")
        }
      },
      {
        // This must be the last object. Any path not matched will fallback to /404
        path: "*",
        redirect: "/404"
      }
    ]
  });

  routerApp.beforeEach(async (to, from, next) => {
    // When a new program is created,
    // we login the creator by setting the auth token in the url via the query key npt (new_program_token)
    if (to.name === "MyDashboard" && to.query.hasOwnProperty("npt")) {
      Vue.auth.token(null, to.query.npt);
    }
    // SSO Reseller Token
    // note, these params come from legacy
    if (
      to.name === "MyDashboard" &&
      to.query.hasOwnProperty("ssort") &&
      to.query.hasOwnProperty("org_id")
    ) {
      try {
        await Vue.auth.login({
          url: "ssoResellerLogin",
          data: {
            nonce: to.query.ssort,
            programId: to.query.org_id
          }
        });
      } catch (error) {
        Dialog.alert({
          title: "SSO Error",
          confirmText: "OK",
          type: "is-danger",
          hasIcon: true,
          message: Vue._.get(
            error.response,
            "data.error.message",
            "An error has occurred. Please try again. Or please reach out to wellness@be-engaged.co."
          )
        });
      }
    }
    // SSO Terryberry Token
    // note, login from Terryberry
    if (
      to.name === "MyDashboard" &&
      to.query.hasOwnProperty("terryberryCode")
    ) {
      let terryberryEnvironment = to.query.hasOwnProperty("environment")
        ? to.query.environment
        : "";
      try {
        await Vue.auth.login({
          url: "terryberryLogin",
          data: {
            terryberryCode: to.query.terryberryCode,
            terryberryEnvironment
          }
        });
      } catch (error) {
        let errorMessage = Vue._.get(
          error.response,
          "data.error.message",
          "An error has occurred. Please try again. Or please reach out to wellness@be-engaged.co."
        );
        if (errorMessage.includes("terryberryUserId")) {
          // errorMessage when a user needs to register there own PII info
          //  has the the 360 user GUID needed to be stored on the member
          //  and looks like: "terryberryUserId=#####"
          Vue.router.push({
            path: "/registration?" + errorMessage
          });
        } else {
          Dialog.alert({
            title: "SSO Error",
            confirmText: "OK",
            type: "is-danger",
            hasIcon: true,
            message: errorMessage
          });
        }
      }
    }

    // beacon-logout clears the identity data, therefore ensuring it is current anytime the Beacon is open
    // and also close the beacon
    window.Beacon("close");
    window.Beacon("logout");
    // only destroy the Beacon when navigation to admin, otherwise the Beacon flickers for every page change
    // note: Beacon('destroy') has some smelly behavior, careful calling it in the same lifecycle as 'init'
    if (
      to.path.includes("admin") ||
      from.path.includes("admin") ||
      to.path.includes("create-bewell")
    ) {
      window.Beacon("destroy");
    }
    next();
  });

  routerApp.afterEach(to => {
    // note: there is no api method to check if there is a mounted Beacon
    // and getting console error "Beacon Error: Invalid method init" if a Beacon is already mounted
    const beaconContainer = window.document.getElementById("beacon-container");
    const beaconExists = beaconContainer && beaconContainer.firstChild;

    let memberAttribute = attribute =>
      Vue._.get(Vue.auth.user(), attribute, "");
    // NOTE: case matters to helpscout
    let helpscoutIdentify = {
      accountEmail: memberAttribute("email"),
      username: memberAttribute("username"),
      firstName: memberAttribute("firstName"),
      lastName: memberAttribute("lastName"),
      "client-type": Vue._.upperFirst(
        memberAttribute("isProgramAdmin") || memberAttribute("isWtAdmin")
          ? "Admin"
          : "Member"
      ),
      "program-name": memberAttribute("program.name"),
      product: Vue._.upperFirst(
        memberAttribute("program.type").replace("product", "")
      ),
      "team-name": memberAttribute("teams[0].name"),
      "registration-date": Vue.prototype
        .moment(memberAttribute("registeredDate"))
        .format("YYYY-MM-DD"),
      "type-of-device-connected": Vue._.upperFirst(
        memberAttribute("externalDevice.deviceName")
      ),
      "manual-entry-allowed": memberAttribute("program.manualEntry")
        ? "Yes"
        : "No",
      "activity-converter-on": memberAttribute("program.converter")
        ? "Yes"
        : "No",
      "registration-open": memberAttribute("program.allowRegistration")
        ? "Yes"
        : "No"
    };

    let name = (
      memberAttribute("firstName") +
      " " +
      memberAttribute("lastName")
    ).trim();
    let helpscoutPrefill = {
      email: memberAttribute("email")
    };
    if (name) {
      helpscoutPrefill.name = name;
    }
    if (to.path.includes("assessment")) {
      window.Beacon("destroy");
    } else if (to.path.includes("/mobile/organizations/")) {
      window.Beacon("destroy");
    } else if (to.path.includes("admin")) {
      window.Beacon("init", "9e1847ed-4329-4b7f-95fe-ba11e2545884");
      if (Vue.auth.check()) {
        window.Beacon("prefill", helpscoutPrefill);
        window.Beacon("identify", helpscoutIdentify);
      }
    } else if (!to.path.includes("create-bewell")) {
      if (!beaconExists)
        window.Beacon("init", "7735db13-d573-4a5a-99a5-24029d38dff8");
      if (Vue.auth.check()) {
        window.Beacon("prefill", helpscoutPrefill);
        window.Beacon("identify", helpscoutIdentify);
      }
    }
  });
  Vue.router = routerApp;
}

// Handle Cache/Lazy-Load Errors
Vue.router.onError(error => {
  // Loading chunk X failed or Loading CSS chunk chunk-x failed
  if (/loading .* *chunk .* failed/i.test(error.message)) {
    Dialog.confirm({
      title: "Refresh Needed",
      confirmText: "Refresh",
      type: "is-warning",
      hasIcon: true,
      message: "The app has been updated.",
      onConfirm: async () => {
        window.location.reload();
      }
    });
  }
});

export default Vue.router;
